module.exports = __webpack_public_path__ + "static/media/une-actions-on-google-intro.6151eebd.png";